import { observer } from "mobx-react";
import { MobXProviderContext } from "mobx-react";
import { useContext } from "react";
import { GroupUsersIcon } from "assets/img";
import { useNavigate } from "react-router-dom";

function StartGroupOrderBadge({ address, menu }) {
  const store = useContext(MobXProviderContext);
  const navigate = useNavigate();
  let { orderDeadline } = store.mealManagementStore;

  function parseDeadline(deadline) {
    if (typeof deadline !== "string") return null;

    // Remove 1st, 2nd, 3rd, 4th... from the date string
    const cleaned = deadline?.replace(/(\d+)(st|nd|rd|th)/, "$1");
    const date = new Date(cleaned);

    if (isNaN(date?.getTime())) return null;
    return date;
  }

  function isDeadlinePassed(deadline) {
    const deadlineDate = parseDeadline(deadline);
    if (!deadlineDate) return false; // invalid or missing date → treat as not passed

    const now = new Date();
    return deadlineDate < now;
  }

  const onClickStart = () => {
    if (isDeadlinePassed(orderDeadline)) {
      store.userStore?.setErrorAlert(true, {
        title:
          "The group order cannot be created because the deadline has passed.",
      });
      return;
    }

    store.mealManagementStore.setCurrentGroupOrder(null);
    navigate("/group-order/new", { state: { menu: menu } });
  };

  return (
    <div className="flex flex-col w-full sm:flex-row p-6 sm:mt-4 bg-background rounded-xl sm:items-center sm:justify-between">
      <div className="flex flex-col w-full sm:w-[70%]">
        <div className="flex gap-2">
          <img src={GroupUsersIcon} alt="group-user-icon" className="icon" />
          <span className="text-md font-inter-semibold">Group order</span>
        </div>

        <span className="text-sm mt-3">
          Easily share order with friends and colleagues so each person can add
          items
        </span>
      </div>

      <div>
        <button
          onClick={onClickStart}
          className="w-[86px] text-white btn-style py-[10px] px-6 text-md mt-4 bg-hh-accent-light hover:bg-hh-accent-medium rounded-[32px]"
        >
          Start
        </button>
      </div>
    </div>
  );
}

export default observer(StartGroupOrderBadge);
